import React from "react";
import "./Get_started.css";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import eth from "../Assets/eth_slider.png";
import getting from "../Assets/get_started_bg.png"
// Import story images
import story8 from "../Assets/19.jpg";
import story9 from "../Assets/20.jpg";
import story10 from "../Assets/21.jpg";
import story11 from "../Assets/22.jpg";
import story12 from "../Assets/11.jpg";
import story13 from "../Assets/12.jpg";

// import required modules
import { Autoplay,EffectCoverflow } from "swiper/modules";

export default function Get_started() {
  return (
    <div className="main_get_Start_page">
      <div className="container">
      <img src={getting} className="getting_started_bg" alt="" />
        <h1 className="get_started_head">
          Get started with Falco P <br /> WING P Collection
        </h1>
        <div className="athletic-mission text-center mb-4">
          <p className="mission-text">HARNESSING THE INHERENT QUALITIES OF THE FALCON</p>
          <p className="mission-subtext">Agility, keen perception and adaptability</p>
        </div>
        <div className="row mt-5">
        <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}  
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: true,
        }}
        loop="true"
            autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        // pagination={true}
        modules={[EffectCoverflow,Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
        <div>
                <img src={story8} className="slider_hulk_img" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">WING P </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
        <SwiperSlide>
        <div>
                <img src={story9} className="hawak_slider" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">Aerodynamic </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
        <SwiperSlide>
        <div>
                <img src={story10} className="hawak_slider" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">Premium </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
        <SwiperSlide>
        <div>
                <img src={story11} className="hawak_slider" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head  pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">Talon-Lock </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
        <SwiperSlide>
        <div>
                <img src={story12} className="hawak_slider" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">Feather-Line </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
        <SwiperSlide>
        <div>
                <img src={story13} className="hawak_slider" alt="WING P Story" />
                <div className="slider_content">
                  <h1 className="slider_card_head pop_font">WING P Story</h1>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <p className="price_slider pop_font mb-0">Dream </p>
                    <img src={eth} className="eth_slider" alt="" />
                  </div>
                </div>
              </div>
        </SwiperSlide>
       
      </Swiper>



      
        </div>
      </div>
      
    </div>
  );
}
